@if (dataUrl !== null) {
  <img
    class="m-auto [image-rendering:pixelated]"
    [src]="dataUrl"
    [style.width.px]="sizeInPx"
    [style.height.px]="sizeInPx"
    alt="QR code"
    data-cs-mask
  />
}
